export default {
  appendService: '附加服务',
  service1: '开箱检查违禁品',
  service2: '验货核对（含验货拍照）',
  service3: '取出发票（可减少征税概率）',
  service4: '原箱入库',
  transportTips: 'acbuy的转发服务默认不提供产品确认。如果您需要产品确认，请选择“产品确认”。',
  selectWarehouse: '选择仓库',
  inputExpressInfo: '填写转发快递信息',
  selectLogistics: '选择物流公司',
  inputTrackNum: '输入快递单号',
  inputNameOrUrl: '填写商品名称或粘贴商品URL',
  selectItemCategory: '选择分类',
  inputRemark: '备注尺寸、颜色或其他信息',
  itemName: '商品名字',
  addPackage: '添加包裹',
  notice1: '1、根据海关政策，所有包裹都会开箱检查是否有违禁物品。谢谢您的理解。',
  notice2:
    '2、请在订单确认后15天内到订单清单完成物流信息（需要人工审核的订单，请及时确认风险信息）；',
  notice3:
    '3、如果您发送到acbuy指定仓库的包裹没有及时填写物流信息，或者没有及时提交转发订单直接发送到我们仓库将被判定为异常。异常部件保存期仅为60天。如因用户物流信息不完整导致异常物品在仓库滞留超过60天，acbuy将对逾期转运货物进行处理，届时货物所有权归acbuy平台所有；',
  notice4:
    '4、请提前与寄件人确认件数及物流号。如果转运包裹是一票多件或亲子包裹，请为每个包裹提交相应的单号订单，并填写相应的物流单号。例如，一张票中有3个物流订单号。，填写3个包裹的物流号；',
  contactServiceAddress: '请联系客服获取仓库地址。',
  package: '包裹',
  waiting: '等待中...',
  waitTips:
    '很长时间没有回应？可能没有产品信息，请尝试个人<span style="color: #31b38c">软件发货</span>或<span style="color: #31b38c">取消重试</span>',
  addProductTitle: '增加自助购买项目',
  transportAgreement: '《转发包裹检验规则和服务协议》',
  threeThings: '你应该知道的三件事',
  step1: '转运流程',
  step2: '服务范围',
  step3: '转运风险',
  tips1: '转运有两个阶段。 转运物品会先审核，寄送前建议做好国际运费评估。',
  tips2: '【阶段一】先在线提交要转运的物品，进行审核，审核通过后再进行购买并寄送至acbuy指定仓库。',
  tips3:
    '【阶段二】物品入库后， 可同其他在库商品进行组合生成包裹订单。 支付订单费用后，就能开始国际运送。',
  tips4: '跨境运费估算工具 >',
  tips5: '对转运的物品只做违禁品核查及合箱，不提供具体盘点及专业质量检测服务。',
  tips6:
    'acbuy仅对要转运的物品做违禁品排查，以及数量、颜色、尺码等信息进行简单核对，不做具体盘点和质检。如商品有少件，请自行联系发件人进行核实。非acbuy原因造成的少件，acbuy不承担相关赔偿责任；特殊及专业性强的商品，则不提供专业的检验服务；非acbuy采购物品，请通过acbuy提供的验货照片自行核对。如需更全面的物品保障及验货服务，建议使用acbuy代购及自助购转运服务。',
  tips7: '包裹由第三方物流商承运,受海关政策限制且可能存在物流风险，需要自行评估并承担。',
  tips8:
    'acbuy作为服务平台，集成众多第三方国际物流商为您提供代购商品的包裹寄送服务，但并不承担由于海关政策和跨境物流中不可控因素造成的风险，如罚没、损坏、丢件、高峰期寄送延迟等。 acbuy将通过提供及时的风险提醒和不断完善的物流保险等措施来辅助您进行风险预估，降低损失概率。',
  confirmNext: '下一步',
  goPrev: '上一步',
  acceptAgreement: '我理解并接受这些条款。',
  iAgreedContinue: '我同意，继续',
}
